/* Sticky add-to-cart behaviour for the OC buy box.
 *
 * On an advertorial product page the buy box sits far down the page, so the bar
 * must appear WHILE the shopper is still reading the content above it — not only
 * after they have scrolled past it. Behaviour:
 *   - hidden until the shopper is past the first screen
 *   - hidden again while the buy box itself is on screen (the real CTA is right there)
 *   - the bar's button scrolls to the buy box when the buy box is out of view,
 *     and adds to cart once the shopper is at/below it
 */
(function () {
  function init(root) {
    if (!root || root.dataset.ocStickyInit) return;
    var sticky = root.querySelector('[data-oc-sticky]');
    var buy = root.querySelector('.oc-buy');
    var btn = root.querySelector('[data-oc-sticky-atc]');
    if (!sticky || !buy || !btn) return;
    root.dataset.ocStickyInit = '1';

    var REVEAL_AFTER = 500;

    function buyInView() {
      var r = buy.getBoundingClientRect();
      return r.top < window.innerHeight * 0.8 && r.bottom > 80;
    }

    function update() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      sticky.classList.toggle('is-visible', y > REVEAL_AFTER && !buyInView());
      btn.textContent = buyInView() ? btn.dataset.atcLabel : (btn.dataset.jumpLabel || 'Check Availability');
    }

    btn.dataset.atcLabel = btn.textContent.trim();
    btn.dataset.jumpLabel = sticky.dataset.jumpLabel || 'Check Availability';

    // When the buy box is off screen the bar should take the shopper to it
    // rather than silently adding an unconfigured item to the cart.
    btn.addEventListener(
      'click',
      function (e) {
        if (!buyInView()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          buy.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }
      },
      true
    );

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function boot() {
    document.querySelectorAll('[data-oc-buy]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Theme editor re-renders sections without a full page load
  document.addEventListener('shopify:section:load', boot);
})();
